import React from 'react';

const SIZE = {
  sm:  { wrap: 'w-7 h-7',  text: 'text-[10px]' },
  md:  { wrap: 'w-9 h-9',  text: 'text-[12px]' },
  lg:  { wrap: 'w-11 h-11', text: 'text-[14px]' },
};

const COLORS = [
  'bg-accent text-primary',
  'bg-primary text-white',
  'bg-teal-600 text-white',
  'bg-violet-600 text-white',
  'bg-emerald-600 text-white',
];

function colorForInitials(initials) {
  let n = 0;
  for (const c of initials) n += c.charCodeAt(0);
  return COLORS[n % COLORS.length];
}

export function Avatar({ initials, size = 'md', className = '' }) {
  const { wrap, text } = SIZE[size] || SIZE.md;
  const color = colorForInitials(initials || '?');
  return (
    <div className={`${wrap} rounded-full ${color} grid place-items-center font-semibold ${text} flex-shrink-0 ${className}`}>
      {initials}
    </div>
  );
}

export function AvatarGroup({ avatars = [], max = 4 }) {
  const visible = avatars.slice(0, max);
  const overflow = avatars.length - max;
  return (
    <div className="flex -space-x-2">
      {visible.map((a, i) => (
        <Avatar key={i} initials={a} size="sm" className="ring-2 ring-white" />
      ))}
      {overflow > 0 && (
        <div className="w-7 h-7 rounded-full bg-slate-200 ring-2 ring-white grid place-items-center font-semibold text-[10px] text-slate-600 flex-shrink-0">
          +{overflow}
        </div>
      )}
    </div>
  );
}

export default Avatar;
